/**
 * @file Constant.js
 * @desc 常量，包含接口路径，独立页面内公共常量
 * @author ~~
 * @data 2021/05/10
 */
import {getPlatInfo} from '@baidu/map-fe-utils';

const Const = {};
// 开发机环境
if (process.env.NODE_ENV === 'development') {
    Const.server = 'https://content.map.baidu.com/mapcjhactivity/';
    // Const.server = 'http://jinyi02-2020-001.bcc-bdbl.baidu.com:8888/';
    // Const.server = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8012/';
    // Const.server = 'http://yq01-ps-201706-m22-9-www0898.yq01.baidu.com:8066/';
}
// QA环境
else if (process.env.NODE_ENV === 'test') {
    Const.server = 'https://content.map.baidu.com/mapcjhactivity/';
    // Const.server = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8005/';
    // Const.server = 'http://yq01-pixiu-engine38.yq01.baidu.com:8023/';
    // Const.server = 'http://wangweiguo.bcc-bdbl.baidu.com:8019/';
}
// 线上环境
else {
    Const.server = 'https://content.map.baidu.com/mapcjhactivity/';
    // Const.server = 'http://jinyi02-2020-001.bcc-bdbl.baidu.com:8888/';
    // Const.server = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8012/';
    // Const.server = 'http://bjyz-ps-201608-m22-nwise0989.bjyz.baidu.com:8005/';
    // Const.server = 'http://yq01-ps-201706-m22-9-www0898.yq01.baidu.com:8066/';
}

// 开发测试配置
if (process.env.NODE_ENV === 'development') {
    /** ****** offline ***** */
    Const.devTap = {
        needBackToNative: false,
        isNative: true,
        backUrl: location.origin + location.pathname,
        mainUrl: 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/pano-game.html',
        erCode: 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/ercode.png',
        mockLogin: 1
    };
}
else {
    /** ****** online ****** */
    Const.devTap = {
        // JumpFunc中通用调端方法中，是否需要调起端的参数
        needBackToNative: true,
        // 基础store中，判断页面当前是否在端内
        isNative: getPlatInfo().isNative,
        // JumpFunc中通用调端方法中，返回端内时的默认地址
        backUrl: 'https://scenes.map.baidu.com/static/subpages/pano-game/pano-game.html',
        // backUrl: location.origin + location.pathname,
        // 基础store中，默认分享url
        mainUrl: 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/pano-game.html',
        // mainUrl: location.origin + location.pathname,
        // 基础store中，默认分享url对应的ercode
        erCode: 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/ercode.png',
        // 基础store中，判断用户是否登录
        mockLogin: 0
    };
}

Const.dataUrl = {
    /**
     * 主页数据
     */
    main: {
        isMock: 0,
        url: Const.server + 'activity/panoexplorer/getbaseinfo'
    },
    // 大逃杀主接口
    getEscapeMain: {
        isMock: 0,
        url: Const.server + 'activity/panoexplorer/panoglorybaseinfo'
    },
    // 闯关主接口
    getKingRoadMain: {
        isMock: 0,
        url: Const.server + 'activity/panoexplorer/getKingRoadBaseInfo'
    },
    /** *********答题页************ */
    /**
     * 获取题目
     */
    getQuestion: {
        isMock: 0,
        url: Const.server + 'activity/panoexplorer/getsubject'
    },
    /**
     * 获取答案
     */
    getAnswer: {
        isMock: 0,
        url: Const.server + 'activity/panoexplorer/getanswer'
    },
    // 复活接口
    resurrection: {
        isMock: 0,
        url: Const.server + 'activity/panoexplorer/revived'
    },
    // 复活状态
    help: {
        isMock: 0,
        url: Const.server + 'activity/panoexplorer/assist'
    },
    // 通关页接口
    passData: {
        isMock: 0,
        url: Const.server + 'activity/panoexplorer/getclearance'
    },
    // 放弃接口
    giveUp: {
        isMock: 0,
        url: Const.server + 'activity/panoexplorer/giveup'
    },
    /**
     * 完成大运营任务
     */
    finishMainTask: {
        isMock: 0,
        url: Const.server + 'activity/main/finishtaskbigoperate'
    },
    // 未使用到，需要确认是否需要保留
    // getWelfareInfo: {
    //     isMock: 0,
    //     url: Const.server + 'activity/panogame/getwelfareinfo'
    // },
    // 获取抽奖任务页数据
    getTaskLotteryInfo: {
        isMock: 0,
        url: Const.server + 'activity/panoexplorer/gettasklotteryinfo'
    },
    // 抽奖
    lottery: {
        isMock: 0,
        url: Const.server + 'activity/panoexplorer/lottery'
    },
    // 完成任务
    finishTask: {
        isMock: 0,
        url: Const.server + 'activity/panoexplorer/finishtask'
    },
    // 更新金币数
    getCoins: {
        isMock: 0,
        url: Const.server + 'activity/panoexplorer/getcoins'
    },
    // 获取错题
    getWrongQuestion: {
        isMock: 0,
        url: Const.server + 'activity/panoexplorer/getwrongquestion'
    }
};

// 设置mock接口
Const.mockFunctions = [
    // 'main',
    // 'getEscapeMain',
    // 'getKingRoadMain',
    // 'getQuestion',
    // 'getAnswer',
    // 'resurrection',
    // 'help',
    // 'passData',
    // 'giveUp',
    // 'getTaskLotteryInfo',
    // 'lottery',
    // 'finishMainTask',
    // 'finishTask',
    // 'getCoins',
    // 'getWrongQuestion'
];
Const.mockFunctions.forEach(item => {
    Const.dataUrl[item].isMock = 1;
});

// 图片
import rebackBg from '../assets/v2/pano/rebackBoxBg.png';
import ansRight from '../assets/v2/pano/ansRightBox.png';
// 默认题目数量（简单模式+新手引导）
Const.defaultTopicNum = 3;
// 大逃杀默认秒数
Const.defaultEscapeTopicNum = 10;
Const.defaultEscapeCountDown = 20;

// 版本
Const.abtest = {
    isV4: 'v4',
    isV3: 'v3',
    isV2: 'v2'
};

// 中断判断
Const.continue = {
    yes: 1,
    no: 2
};

// 各个页面的预加载图片配置
Const.preloadImgs = {
    main: [],
    escape: [],
    note: [],
    kingRoad: [],
    welfare: [],
    pano: {
        escape: [],
        kingRoad: [],
        newPeople: [rebackBg, ansRight],
        ordinary: [rebackBg, ansRight],
        master: [rebackBg, ansRight]
    }
};

// 游戏类型
Const.gameMode = {
    // 新人模式
    newPeople: 'newPeople',
    // 达人模式（简单）
    ordinary: 'ordinary',
    // 大师模式（困难）
    master: 'master',
    // 大逃杀模式
    escape: 'escape',
    // 闯关模式
    kingRoad: 'kingRoad'
};

// 游戏状态
Const.gameStatus = {
    // 进行中
    doing: 0,
    // 通关
    pass: 1,
    // 失败
    fail: 2
};

// 商城类型
Const.welfareType = {
    coin: 'coin',
    medal: 'medal'
};

// 大逃杀荣誉墙数据单位
Const.escapeHonorTypeSymbols = {
    challengeNum: '次',
    answerRightNum: '题',
    totalParticipateNum: '次',
    clearanceTotalNum: '次',
    clearanceRate: '%',
    totalChallengeDayNum: '天',
    continuityClearanceNum: '次',
    time: '秒'
};

// 默认头像
Const.defaultAvatar = 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/escape/defaultAvatar.png';

// 闯关模式，关卡类型
Const.levelTypes = {
    easy: 0,
    hard: 1
};

// 闯关模式，关卡状态
Const.levelStatus = {
    finished: 0,
    open: 1,
    locked: 2
};

// 奖品类型
Const.prizeInfoType = {
    coin: 'coin',
    cash: 'cash',
    dachequan: 'dachequan'
};

// 任务状态
Const.taskType = {
    ordinary: 'tordinary',
    note: 'twrong',
    share: 'tshare'
};

// 任务状态
Const.taskStatus = {
    wait: 0,
    fixed: 1,
    received: 2
};

// 首页弹窗
Const.mainDialogNum = {
    // 规则
    rules: 1,
    // 挽留弹框
    askToStay: 2,
    // 活动状态
    statusBox: 3,
    // 有未完成的状态
    notFinish: 4,
    // 助力状态
    helpStatus: 5,
    // 没有金币
    noCoin: 6,
    // 用户须知 授权的
    noticeToKnow: 7,
    // 闯关模式，使用金币提示
    useCoin: 8,
    // 抽奖中现金
    redBag: 9
};

// 答题页弹窗
Const.panoDialogNum = {
    // 回答正确
    ansRight: 1,
    // 回答错误
    ansWrong: 2,
    // 度口令
    duWord: 3,
    // 复活
    reBack: 4,
    // 每日或者金币复活成功
    norReBackSuccess: 5,
    // 好友助力复活成功
    friendReBackSuccess: 6,
    // 等待好友助力
    waitHelp: 7,
    // 通关一组题
    pass: 8,
    // 红包
    getRedBag: 9,
    // 新手复活
    newUserReBack: 10,
    // 挽留弹窗
    askToStay: 11
};

Const.posterType = {
    escape: 'escape',
    kingRoad: 'kingRoad',
    normal: 'normal'
};

// 生成海报服务
Const.posterService = {
    appKey: 'pano_cctv',
    domain: 'https://pano-cctv.bj.bcebos.com/',
    bucket: 'pano-cctv',
    imgPath: 'pano-cctv/share-pic/',
    stsService: 'https://mbc.baidu.com/bdpmng/sts?app=pano_cctv'
};

// 生成海报的预加载图片
Const.posterTypeImages = {
    normal: [
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/share/tipTextBg.png',
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v2/share/passShareBoxBg.png',
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v2/share/passShareLogo.png',
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v2/share/passShareSubText.png',
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v2/share/passShareErWeima.png',
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v2/share/passShareTextBox.png'
    ],
    escape: [
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/share/ercodeBg.png',
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/share/posterBgEs2.png',
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/share/logo.png',
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/share/posterTitleEs2.png',
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/share/posterSubTitleEs2.png',
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/share/dataFrameEs2.png'
    ],
    kingRoad: [
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/share/ercodeBg.png',
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/share/posterBg.png',
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/share/logo.png',
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/share/dataFrame.png',
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/share/posterTitle.png',
        'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/share/posterSubTitle.png'
    ]
};

// 0-9特殊字体
Const.specialFontImgs = {
    italic: {
        '0': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/kingRoad/italic/0.png',
        '1': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/kingRoad/italic/1.png',
        '2': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/kingRoad/italic/2.png',
        '3': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/kingRoad/italic/3.png',
        '4': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/kingRoad/italic/4.png',
        '5': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/kingRoad/italic/5.png',
        '6': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/kingRoad/italic/6.png',
        '7': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/kingRoad/italic/7.png',
        '8': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/kingRoad/italic/8.png',
        '9': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v4/kingRoad/italic/9.png'
    },
    white: {
        '0': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/white/0.png',
        '1': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/white/1.png',
        '2': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/white/2.png',
        '3': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/white/3.png',
        '4': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/white/4.png',
        '5': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/white/5.png',
        '6': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/white/6.png',
        '7': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/white/7.png',
        '8': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/white/8.png',
        '9': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/white/9.png',
        '%': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/yellow/percent.png',
        '-': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/yellow/line.png'
    },
    yellow: {
        // '0': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/yellow/0.png',
        // '1': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/yellow/1.png',
        // '2': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/yellow/2.png',
        // '3': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/yellow/3.png',
        // '4': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/yellow/4.png',
        // '5': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/yellow/5.png',
        // '6': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/yellow/6.png',
        // '7': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/yellow/7.png',
        // '8': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/yellow/8.png',
        // '9': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/yellow/9.png',
        // '%': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/yellow/percent.png',
        // '-': 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/special/yellow/line.png'
        '0': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXBAMAAADn+kIjAAAAMFBMVEUAAAD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wDfLJoNAAAAD3RSTlMAd7tEZqrMMxHdme6IVSLwJQqoAAAApElEQVQY00WNzQ0BURhFD4YIEVRANEDyChglWNhbKICoQAd0QAda0IkS/P+F5M3N+/Jm7ubkbs4Bkm4+YObjfpD4fDcoFe8JZWHunBOuUBOOgPCAttCBinCHszCClvCBVFia7AI9AWgI/fC+mHoCw1ClabKF939MPQarkgZ13TqcxHWovonqxDocvH9ZdUtUV63KTjKr2vTUsZlsU7w9rAZxU8gAf7yvhFzWweYAAAAASUVORK5CYII=',
        '1': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXBAMAAADn+kIjAAAAMFBMVEUAAAD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wDfLJoNAAAAD3RSTlMAu3dE7ohm3cyqmVUzIhH++L92AAAAh0lEQVQY00XPyw2CQBSF4QFfiZro7NxptADtQFuwAuiEEqAzFjRACbxCAoRczgTu4d99i5ncY+ay580sbf6xSKPaCSpVnlOvOjhVKv8FDYbfQDV1ggrKh37UEbpSHpRQW+hBXaCQSqEP9YVy6g0ZFrgJ7C7SrYrcBIZnLXHWCRw0Untr7Xz0BJ0+UYbGtSquAAAAAElFTkSuQmCC',
        '2': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXBAMAAADn+kIjAAAAMFBMVEUAAAD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wDfLJoNAAAAD3RSTlMAu3dEEYju3cxmVTMiqplgES1XAAAAkElEQVQY01XNuw3CUAxG4QMJAgQoiVgAQUUXkQGSiho2YBPEJmzCCKzACOHV0BhLVmzlK+6v01xDsnZbGIn7wiDqBeOoH2Q6m6ra6bzhplPCVKeFWqeBoc6JzkIrx9jXD4x9toKzuCtIKJlJgETfS2HsTomxanp3cBORJyaFzCtdwl3cB+qoFvZROcyPRefAH1BVmge7wfcmAAAAAElFTkSuQmCC',
        '3': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXBAMAAADn+kIjAAAALVBMVEUAAAD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wDuQmXVAAAADnRSTlMAu3dEme5mM92IVaoiEVY8QSUAAACKSURBVBjTVc+7DcJQDEbhEy6PAiGRBRCioIwQ9DT0jIDEBoyQERiBiZghvISg8AyYRPmtnO4rbNmQFmoJfVMfyEJ3GIQekDZ1a9ebtqGrknquUhq7plLmOsMor5u55v8Btero1LkFVZi9QnuzW8h3PkMHf0GYmNlXSs1DV1MVbEMlFKELHPO2HfwATQWGLFgUhlsAAAAASUVORK5CYII=',
        '4': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXBAMAAADn+kIjAAAAMFBMVEUAAAD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wDfLJoNAAAAD3RSTlMAd0S7IojdzKpV7jOZZhFSGQMqAAAAtklEQVQY00WP3QnCQBCEJ/6QgIg5G/AI+KxyBSg2oB1oB5agnWgHpgQ70BaswP+IT+vcJuHmYYZvYZldAIbKr7Q+qL2IzLq0h6eVSIEW6elpK/JBg/QGdPpDRL+TNNXXpIS5Q5M+Jt2YKWL6si5AT2fA2RdgQbKkoy/AiJQDHS3AgAGgzTgoFaRYCzAVeaFcnxizEfkay/WglAtBNpAeMc+8hv69DJUi7amV6AuV9KFTIOfcBfgDzwaaEgQ68G8AAAAASUVORK5CYII=',
        '5': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXBAMAAADn+kIjAAAAKlBMVEUAAAD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wBoaeyRAAAADXRSTlMAd0S7M8yqmWYiiBHdFs5NTQAAAI1JREFUGNNjYHAURAAGBva7CMDAwIjgXEbhXWNgYAZSQUpgoMnAwArkLWCAAV4gTwDOmwvkKcB5ukBeIcQ6oBJZhJkGKLwEBgZbBA+o0gliF0h7A9wwXwyjJ0DZEMMY4GDt3btXGRi4oTxbsIeYoQadvXv3IshDUADm8SJ4VxgY9iJ4BQwMzsYwkMHAAAAjP3/HolTt3gAAAABJRU5ErkJggg==',
        '6': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXBAMAAADn+kIjAAAAMFBMVEUAAAD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wDfLJoNAAAAD3RSTlMAu3dEiN0zVSIRzJlm7qofzgWzAAAAlklEQVQY00WPQQ4BQRBFH4OIzZgTEGsJiZXVEAfgBo7ADbiBE0jcxJUYCREyPZXqdNVb/M7bvE5BNjGm0AnGD1puFXTdPpDLs1koSziIzUmUYmezmRjGVqyIjGHkTbG92xFcJN2TfQEnjWWyb0u3ZR/APYRntB2aruMJQzRdwUD/0fQfcrWUvgTjC6WbpK9uN+ivi8SKBv03qcbopxoSAAAAAElFTkSuQmCC',
        '7': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXBAMAAADn+kIjAAAAMFBMVEUAAAD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wDfLJoNAAAAD3RSTlMAd0S77iIR3YiqZlXMmTOmPGZUAAAAbUlEQVQY02NgE0QABgam/wjAwMCI4HxG5/EpgYEWkPeLAQaYgTwDOE8fyFOA8+r///8LZULMcoXzUoA8ATiv////73AOK1DqNx7zA5DN/4Fivhtu8/+gmP8JxfwJyOZ/QTH/I5zDbWxsPA3CBADYT2KvTLHkvwAAAABJRU5ErkJggg==',
        '8': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXBAMAAADn+kIjAAAALVBMVEUAAAD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wDuQmXVAAAADnRSTlMAu3dEzGYzqiIR3ZnuiGuU+CEAAAChSURBVBjTVY+9CQJBFAbn1FNMDjc1ELEAES4Xwfxq0CLMrcASxBKswBLEEu78xWRr8GOX24cvGSaZjwfks3TAxaeD3KSBjtkHMmFdluXV+zv0ZDdAeEEhTKEvPOAgLKArfGEpbGKshrngnBsLK2TpRjAxU6z6M69V2vQw7MT0Puy8USy9UEd7xtUTId3AIO5QhVhmA7LCTLGj2Rm2rr0d/AAd4K7LpVOyswAAAABJRU5ErkJggg==',
        '9': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAXBAMAAADn+kIjAAAALVBMVEUAAAD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wD6/wDuQmXVAAAADnRSTlMAd7tEmVXuzIgzIhHdZgXkY5QAAACaSURBVBjTRY/NCcJAFAbHP9AgkjQgYgEiLHgUQbyKWIEVWIIlWII1WIE1WIKamNy2hnyw5L25DEPItzyYFA70ovGDsVcFfa8vTKV9CEH6w0x6w0Aq4SGtYSR9YCs90/QF5hIwlBZw1zuk6R2sYmw0uVHlcIvGCTw0nUUHsiKh32uMo6a99K3yuuoEr+4Eo4SXRTrByOG87DhAC0F9np3FMLmaAAAAAElFTkSuQmCC',
        '%': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAmBAMAAACv7X8tAAAAMFBMVEUAAAD5/wD5/wD5/wD5/wD5/wD5/wD5/wD5/wD5/wD5/wD5/wD5/wD5/wD5/wD5/wDRvw8yAAAAD3RSTlMARLsRzDPuZneZ3aqIIlV3UltbAAABQUlEQVQoz2WSP04CURDGRxDFPxHxAhIbS7cwFjYaPYDa0FpZWcgN5AZwAzUeQG+A8QLiCWwtV9woEMJjvv1mAjx+xey8Xza7M1+eRNQDaGj3vkf2oTdhR+juAvnHYRddG10wfrQv4Z0Mdsn1rx6O0ZxDb7lORYoX+vy7hC5r97Sj5VRkIyg34v+uFVBEHjgdgGmvaGlK2QYC6zCVXN/bdACmca1luwQ7EAJzhgm6dZ+OexnFF6ySmG6ZzQ45nfFhutfhKsYBHAync66qpMNVIlY5XYQHHcGgk1gfcZUIBD0lpbSgb10/UlrQ365rlBZ0wfUbrQW97LpJa0FXYE6QPLUF/QWDtZiXB50bfE9yGDSTRxlSW9AwGQ49AWsM2pP3HFsetAfQnw86GGNeCOUVAy3e6GT2Rqd+o58l5rOqdGM7AYtyn1gEsPS+AAAAAElFTkSuQmCC',
        '-': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAFCAYAAACaTbYsAAAAQUlEQVQYlWNkYGBg+PmfIY2BgUGQgTRwFqb5LgMDgxKJmitgmv+TqBEEXJl+/mdwIUMjCNxjAREgJ5Cqk52R4R4Acv4PR/eyiiIAAAAASUVORK5CYII='
    }
};


export default Const;
